import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-credit-emprunteur',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-credit-emprunteur.component.html',
  styleUrls: ['./assurance-credit-emprunteur.component.scss']
})
export class AssuranceCreditEmprunteurComponent {
  title = 'Assurance Crédit Emprunteur';
  subtitle = 'Assurez votre emprunt immobilier';
  phoneNumber = '07 57 93 35 00';
  additionalPhoneNumber = '07 57 93 36 00';
  heroCtaLabel = 'Obtenir un devis gratuit';
  heroCtaLink = '/devis-emprunteur';
  heroVideo = 'assets/videos/creditEmprunteur.mp4';
  
  breadcrumbs =   [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance Crédit Emprunteur', link: undefined }
  ];


  prevPage = undefined;
  
  nextPage = { 
    title: 'Assurance Prévoyance Particuliers',
    link: '/assurance-prevoyance-particuliers'
  };

  // Partner logos
  partners = [
    { name: 'GENERALI', logo: 'assets/images/logos/generali-logo.png' },
    { name: 'CARDIF', logo: 'assets/images/logos/cardif-logo.png' },
    { name: 'AFIESCA', logo: 'assets/images/logos/afiesca-logo.png' },
    { name: 'APRIL', logo: 'assets/images/logos/april-logo.png' },
    { name: 'SWISSLIFE', logo: 'assets/images/logos/swisslife-logo.png' },
    { name: 'UTWIN', logo: 'assets/images/logos/utwin-logo.png' }
  ];

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }

  navigateToDevis(): void {
    this.router.navigate(['/devis-emprunteur']);
  }
}

